/**
 * Format a 0-based month date as YYYY-MM-DD
 */
export const formatISODate = (year: number, monthZeroBased: number, day: number): string => {
    const mm = String(monthZeroBased + 1).padStart(2, '0'); // +1 for human-readable month
    const dd = String(day).padStart(2, '0');
    return `${year}-${mm}-${dd}`;
};

/**
 * Get number of days in a month (expects 0-based month)
 */
export const daysInMonth0 = (year: number, monthZeroBased: number): number => {
    return new Date(year, monthZeroBased + 1, 0).getDate();
};
